export default __webpack_public_path__ + "static/doctor-with-patient-b6216aab3f8c3839e2a7af141d9370ce.png";